import { doc, Firestore, setDoc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import type { FirebaseStorage } from 'firebase/storage';

import { Inject, Injectable } from '@angular/core';

import { CrudService } from './firestore-crud.service';
import { FIRESTORE_TOKEN, STORAGE_TOKEN } from './firebase.tokens';

export interface PushToken {
  token: string;
  platform: string;
  userId: string | null;
  /** Origin the permission was granted on; web push links must match it. */
  origin: string | null;
  updated: number;
}

/**
 * Registry of FCM device tokens. The scheduled Cloud Function reads this
 * collection to know where to deliver the daily birthday notification.
 */
@Injectable({ providedIn: 'root' })
export class PushTokensService extends CrudService<PushToken> {
  override collectionName = 'pushTokens';

  constructor(
    @Inject(FIRESTORE_TOKEN) firestore: Firestore,
    @Inject(STORAGE_TOKEN) storage: FirebaseStorage
  ) {
    super(firestore, storage);
  }

  /**
   * Stores the token under its own id, so a device that re-registers updates
   * its entry instead of adding a duplicate.
   */
  async saveToken(token: string, platform: string): Promise<void> {
    const refDoc = doc(this.firestore, `${this.collectionName}/${token}`);

    const payload: PushToken = {
      token,
      platform,
      userId: getAuth().currentUser?.uid ?? null,
      origin: platform === 'web' ? location.origin : null,
      updated: Date.now(),
    };

    await setDoc(refDoc, payload, { merge: true });
  }
}
